const WATERMARK_ID = 'sg-web-user-watermark'
const STYLE_ID = 'sg-web-page-protection-style'
const PROTECTION_FLAG = '__sgWebPageProtectionInstalled__'

const BLOCKED_EVENTS = ['copy', 'cut', 'contextmenu', 'selectstart', 'dragstart']

function getUserWatermarkText(userInfo) {
  if (!userInfo) {
    return ''
  }
  return userInfo.username || userInfo.identifier || userInfo.name || userInfo.realName || userInfo.id || ''
}

function isEditableTarget(target) {
  if (!(target instanceof HTMLElement)) {
    return false
  }
  const tagName = target.tagName.toLowerCase()
  return tagName === 'input' || tagName === 'textarea' || target.isContentEditable
}

function ensureProtectionStyle() {
  if (document.getElementById(STYLE_ID)) {
    return
  }
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.innerHTML = `
html,
body,
#app,
#app * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

input,
textarea,
[contenteditable='true'] {
  -webkit-user-select: text;
  user-select: text;
}
`
  document.head.appendChild(style)
}

function installCopyProtection() {
  if (window[PROTECTION_FLAG]) {
    return
  }
  const preventCopy = event => {
    if (isEditableTarget(event.target)) {
      return
    }
    event.preventDefault()
  }
  BLOCKED_EVENTS.forEach(eventName => {
    document.addEventListener(eventName, preventCopy, true)
  })
  window[PROTECTION_FLAG] = true
}

function renderWatermark(text) {
  let watermark = document.getElementById(WATERMARK_ID)
  if (!text) {
    if (watermark) {
      watermark.remove()
    }
    return
  }
  if (!watermark) {
    watermark = document.createElement('div')
    watermark.id = WATERMARK_ID
    document.body.appendChild(watermark)
  }
  watermark.setAttribute('aria-hidden', 'true')
  watermark.style.cssText = [
    'position: fixed',
    'inset: 0',
    'z-index: 9999',
    'pointer-events: none',
    'background-repeat: repeat',
    'background-size: 220px 160px',
    `background-image: url("${createWatermarkImage(text)}")`
  ].join(';')
}

function createWatermarkImage(text) {
  const canvas = document.createElement('canvas')
  canvas.width = 220
  canvas.height = 160
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    return ''
  }
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.translate(26, 118)
  ctx.rotate((-25 * Math.PI) / 180)
  ctx.font = '16px sans-serif'
  ctx.fillStyle = 'rgba(0, 0, 0, 0.12)'
  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'
  ctx.fillText(text, 0, 0)
  return canvas.toDataURL('image/png')
}

export function refreshWebPageProtection(userInfo) {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return
  }
  ensureProtectionStyle()
  installCopyProtection()
  renderWatermark(getUserWatermarkText(userInfo))
}



// WEBPACK FOOTER //
// ./src/utils/pageProtection.js